
<template>
  <div class="room report-list" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="table-command">
      <el-button @click="triggerCreateRequest()" type="primary" v-if="!isAdmin">创建申请</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%" :max-height="tableMaxHeight">
      <el-table-column align="center" label="序号" type="index" width="100"></el-table-column>
      <el-table-column align="center" label="申请编号" prop="requestId"></el-table-column>
      <el-table-column align="center" label="申请用户" prop="userName"></el-table-column>
      <el-table-column align="center" label="提交时间" prop="createdDate" width="200"></el-table-column>
      <el-table-column align="center" label="申请留言" prop="requestNote"></el-table-column>
      <el-table-column align="center" label="审批管理员" prop="adminName"></el-table-column>
      <el-table-column align="center" label="审批时间" prop="reviewDate" width="200"></el-table-column>
      <el-table-column align="center" label="审批留言" prop="reviewNote"></el-table-column>
      <el-table-column align="center" label="批准过期" prop="approvedExpireDate" width="200"></el-table-column>
      <el-table-column align="center" label="申请状态">
        <template slot-scope="scope">
          <el-tag class="percentage-tag" effect="dark" :type="scope.row.requestStatusTagType">{{ scope.row.requestStatusName }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" v-if="isAdmin">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="triggerReviewRequest(scope.row.requestId)" v-if="scope.row.requestStatusName === '待审批'"
            >审批请求</el-button
          >
          <el-button size="small" @click="triggerDisplayRequest(scope.row.requestId)" v-else>查看审批</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      :style="pageStyle"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      @current-change="currentChange"
      ref="page"
    >
    </el-pagination>

    <!-- 提交申请弹窗 -->
    <el-dialog
      width="620px"
      :visible.sync="createRequestDialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-title" slot="title">提交申请</div>
      <el-form :model="createRequestModel" ref="changeNameForm">
        <el-form-item label="申请用户">
          <span>{{ createRequestModel.userName }}</span>
        </el-form-item>
        <el-form-item label="申请留言">
          <el-input
            type="textarea"
            v-model="createRequestModel.requestNote"
            placeholder="请输入申请留言(可选)"
            :rows="5"
            resize="none"
            class="dialog-form-textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="createRequestDialogVisible = false">取消</el-button>
        <el-button @click="submitCreateRequest" type="primary">确定</el-button>
      </div>
    </el-dialog>

    <!-- 审批申请弹窗 -->
    <el-dialog
      width="620px"
      :visible.sync="reviewRequestDialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="dialog-title" slot="title">审批申请</div>
      <el-form :model="reviewRequestModel" ref="reviewRequestForm" :rules="reviewRequestFormRules">
        <el-form-item label="申请用户" prop="userName">
          <span>{{ reviewRequestModel.userName }}</span>
        </el-form-item>
        <el-form-item label="申请时间" prop="createdDate">
          <span>{{ reviewRequestModel.createdDate }}</span>
        </el-form-item>
        <el-form-item label="申请留言" prop="requestNote">
          <el-input
            type="textarea"
            v-model="reviewRequestModel.requestNote"
            placeholder="请输入申请留言(可选)"
            :rows="5"
            resize="none"
            class="dialog-form-textarea"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="审批结果" prop="reviewType">
          <el-select v-model="reviewRequestModel.reviewType" placeholder="请选择审批结果" :disabled="reviewRequestModel.isDisabled">
            <el-option label="批准" value="APPROVED">
              <el-tag effect="dark" type="success" class="tag-in-select">批准</el-tag>
            </el-option>
            <el-option label="拒绝" value="DENIED">
              <el-tag effect="dark" type="danger" class="tag-in-select">拒绝</el-tag>
            </el-option>
            <el-option label="待审批" value="PENDING" style="margin-top: 5px">
              <el-tag effect="dark" type="primary" class="tag-in-select">待审批</el-tag>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批准期限" prop="approvedSeconds" v-if="reviewRequestModel.reviewType === 'APPROVED'">
          <el-select v-model="reviewRequestModel.approvedSeconds" placeholder="请选择批准期限" :disabled="reviewRequestModel.isDisabled">
            <el-option label="不适用" value="0"> </el-option>
            <el-option label="一天" value="86400"> </el-option>
            <el-option label="三天" value="259200"> </el-option>
            <el-option label="一周" value="604800"> </el-option>
            <el-option label="两周" value="1209600"> </el-option>
            <el-option label="四周" value="2419200"> </el-option>
            <el-option label="八周" value="4838400"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批准过期" prop="approvedExpireDate" v-if="reviewRequestModel.reviewType === 'APPROVED'">
          <span>{{ reviewRequestModel.approvedExpireDate }}</span>
        </el-form-item>
        <el-form-item label="审批留言" prop="reviewNote">
          <el-input
            type="textarea"
            v-model="reviewRequestModel.reviewNote"
            placeholder="请输入审批留言(可选)"
            :rows="5"
            resize="none"
            class="dialog-form-textarea"
            :disabled="reviewRequestModel.isDisabled"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!reviewRequestModel.isDisabled">
        <el-button @click="reviewRequestDialogVisible = false">取消</el-button>
        <el-button @click="submitReviewToConfirm" type="primary">确定</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button @click="reviewRequestDialogVisible = false" type="primary">确定</el-button>
      </div>

      <!--审批确认弹窗-->
      <el-dialog
        width="620px"
        :visible.sync="reviewConfirmDialogVisible"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
      >
        <div class="dialog-title" slot="title">审核确认</div>
        <span>数据历史访问审批一旦提交无法更改. 请再次确认信息正确无误.<br /></span>
        <span v-html="reviewConfirmMessage"></span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="reviewConfirmDialogVisible = false">取消</el-button>
          <el-button @click="submitReviewRequest" type="primary">确定</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import { dateTimeToString, newtonsoftJsonToDate } from "../tools/GeneralTool";

export default {
  name: "HistoryAccessControl",
  data() {
    return {
      loadingFullScreen: null,
      timer: null,
      isAdmin: false,
      userName: "",
      tableData: [],
      requestIdRequestDict: {},
      loading: false,
      shownewUser: false,
      checkUserId: "",
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      deviceNameReplaceList: ["状态", "(枚举)"],
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
      showAllUser: false,
      createRequestModel: {
        requestNote: "",
      },
      reviewRequestModel: {
        requestId: 0,
        userName: "",
        userId: "",
        createdDate: "",
        requestNote: "",
        reviewType: "",
        reviewNote: "",
        approvedSeconds: "",
        approvedExpireDate: "不适用",
        isDisabled: false,
      },
      createRequestDialogVisible: false,
      reviewRequestDialogVisible: false,
      reviewConfirmDialogVisible: false,

      reviewRequestFormRules: {
        approvedSeconds: [{ validator: this.expireDateValidator, trigger: "blur" }],
      },
    };
  },
  created() {
    this.$http.get("/auth/LoginInfo").then((res) => {
      if (res !== undefined && res.data !== undefined) {
        this.isAdmin = res.data.IsAdmin;
        this.userName = res.data.userName;
        this.userId = res.data.userId;
      }
    });
  },
  mounted() {
    this.getData();

    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };
    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    this.pageStyle = {
      left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    },
    createUserDialogVisible(newVal, oldVal) {
      if (newVal) {
        this.$refs.createUserForm.resetFields();
      }
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
        };
      });
    },
    "reviewRequestModel.reviewType"() {
      this.reviewRequestModel.approvedExpireDate = this.calculateApproveExpireDate();

      if (this.reviewRequestModel.reviewType !== "APPROVED") {
        this.reviewRequestModel.approvedSeconds = "";
      }
    },
    "reviewRequestModel.approvedSeconds"() {
      this.reviewRequestModel.approvedExpireDate = this.calculateApproveExpireDate();
    },
  },
  computed: {
    reviewConfirmMessage() {
      let reviewName = this.reviewRequestModel.reviewType;
      if (this.reviewRequestModel.reviewType === "APPROVED") {
        reviewName = '<el-tag effect="dark" type="success" >批准</el-tag>';
      } else if (this.reviewRequestModel.reviewType === "DENIED") {
        reviewName = '<el-tag effect="dark" type="danger" >拒绝</el-tag>';
      } else if (this.reviewRequestModel.reviewType === "PENDING") {
        reviewName = '<el-tag effect="dark" type="primary" >待审批</el-tag>';
      }

      let result = "申请用户: " + this.reviewRequestModel.userName + "(" + this.reviewRequestModel.userId + ")";
      result = result + ", 审批结果: " + reviewName;
      if (this.reviewRequestModel.reviewType === "APPROVED") {
        result = result + ", 有效期至: " + this.reviewRequestModel.approvedExpireDate;
      }

      return result;
    },
  },
  methods: {
    submitCreateRequest() {
      this.loading = true;
      let postBody = {
        requestNote: this.createRequestModel.requestNote,
      };

      this.$http
        .post("/statisticsAccess/SubmitRequest", postBody)
        .then(() => {
          this.$confirm("提交申请成功. 请联系管理员进行审批.", "提示", {
            confirmButtonText: "确定",
            type: "success",
          }).then(() => {
            this.$message({
              message: "提交申请成功",
              type: "success",
            });
            this.createRequestDialogVisible = false;
            this.getData();
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    submitReviewToConfirm() {
      this.$refs.reviewRequestForm.validate().then(() => {
        if (this.reviewRequestModel.reviewType !== "PENDING") {
          this.reviewConfirmDialogVisible = true;
        } else {
          this.submitReviewRequest();
        }
      });
    },
    submitReviewRequest() {
      this.loading = true;
      let postBody = {
        requestId: this.reviewRequestModel.requestId,
        reviewNote: this.reviewRequestModel.reviewNote,
        reviewType: this.reviewRequestModel.reviewType,
        approvedSeconds: parseInt(this.reviewRequestModel.approvedSeconds),
      };
      this.$http
        .post("/statisticsAccess/ReviewRequest", postBody)
        .then(() => {
          this.$message({
            message: "提交审核成功",
            type: "success",
          });
          this.reviewRequestDialogVisible = false;
          this.reviewConfirmDialogVisible = false;
          this.getData();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    expireDateValidator(rule, value, callback) {
      if (
        this.reviewRequestModel.reviewType === "APPROVED" &&
        (this.reviewRequestModel.approvedSeconds === "0" || this.reviewRequestModel.approvedSeconds === "")
      ) {
        callback(new Error("请选择批准时长"));
      }

      callback();
    },
    triggerReviewRequest(requestId) {
      let request = this.requestIdRequestDict[requestId];
      if (!request) {
        this.$message({
          message: "无法找到目标申请: " + requestId,
          type: "warning",
        });
        return;
      }

      this.reviewRequestModel.requestId = requestId;
      this.reviewRequestModel.userName = request.userName;
      this.reviewRequestModel.userId = request.userId;
      this.reviewRequestModel.createdDate = request.createdDate;
      this.reviewRequestModel.requestNote = request.requestNote;
      this.reviewRequestModel.reviewType = request.requestStatus;
      this.reviewRequestModel.reviewNote = request.reviewNote;
      this.reviewRequestModel.approvedSeconds = "";
      this.reviewRequestModel.isDisabled = false;

      this.reviewRequestDialogVisible = true;
    },
    triggerDisplayRequest(requestId) {
      let request = this.requestIdRequestDict[requestId];
      if (!request) {
        this.$message({
          message: "无法找到目标申请: " + requestId,
          type: "warning",
        });
        return;
      }

      this.reviewRequestModel.requestId = requestId;
      this.reviewRequestModel.userName = request.userName;
      this.reviewRequestModel.userId = request.userId;
      this.reviewRequestModel.createdDate = request.createdDate;
      this.reviewRequestModel.requestNote = request.requestNote;
      this.reviewRequestModel.reviewType = request.requestStatus;
      this.reviewRequestModel.reviewNote = request.reviewNote;
      this.reviewRequestModel.approvedSeconds = request.approvedSeconds + "";
      this.reviewRequestModel.isDisabled = true;

      this.reviewRequestDialogVisible = true;
    },
    triggerCreateRequest() {
      this.createRequestModel.userName = this.userName + "(" + this.userId + ")";
      this.createRequestModel.requestNote = "";

      this.createRequestDialogVisible = true;
    },
    calculateApproveExpireDate() {
      if (
        this.reviewRequestModel.reviewType !== "APPROVED" ||
        this.reviewRequestModel.approvedSeconds === "0" ||
        this.reviewRequestModel.approvedSeconds === ""
      ) {
        return "不适用";
      }

      let approvedSeconds = parseInt(this.reviewRequestModel.approvedSeconds);
      let startDate = new Date();
      let endDate = new Date(startDate.getTime() + approvedSeconds * 1000);
      let result = this.dateTimeToString(endDate, "yyyy年MM月dd日 HH时mm分");
      return result;
    },
    refreshData() {
      this.getData();
    },
    currentChange(index) {
      this.currentPage = index;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.getDataCount();
      this.getDataList();
    },
    getDataCount() {
      let url = "/statisticsAccess/GetStatisticsAccessRequestCount";

      this.$http.get(url).then((res) => {
        this.totalCount = res.data.count;
      });
    },
    getDataList() {
      let startIndex = (this.currentPage - 1) * this.pageSize;

      this.$http.get("/statisticsAccess/GetStatisticsAccessRequest?start=" + startIndex + "&limit=" + this.pageSize).then((res) => {
        let dataList = res.data;

        dataList.forEach((dataItem) => {
          dataItem.requestStatusTagType = "info";
          dataItem.allowReview = false;
          if (dataItem.requestStatus === "PENDING") {
            dataItem.requestStatusTagType = "primary";
            dataItem.requestStatusName = "待审批";
            dataItem.allowReview = true;
          } else if (dataItem.requestStatus === "APPROVED") {
            let expireDate = newtonsoftJsonToDate(dataItem.approvedExpireDate);

            if (new Date().getTime() > expireDate.getTime()) {
              dataItem.requestStatusTagType = "warning";
              dataItem.requestStatusName = "过期";
            } else {
              dataItem.requestStatusTagType = "success";
              dataItem.requestStatusName = "批准";
            }
          } else if (dataItem.requestStatus === "DENIED") {
            dataItem.requestStatusTagType = "danger";
            dataItem.requestStatusName = "拒绝";
          }

          dataItem.createdDate = dateTimeToString(newtonsoftJsonToDate(dataItem.createdDate), "yy年MM月dd日 HH时mm分");
          if (newtonsoftJsonToDate(dataItem.reviewDate).getTime() > 0) {
            dataItem.reviewDate = dateTimeToString(newtonsoftJsonToDate(dataItem.reviewDate), "yy年MM月dd日 HH时mm分");
          } else {
            dataItem.reviewDate = "";
          }
          if (newtonsoftJsonToDate(dataItem.approvedExpireDate).getTime() > 0) {
            dataItem.approvedExpireDate = dateTimeToString(newtonsoftJsonToDate(dataItem.approvedExpireDate), "yy年MM月dd日 HH时mm分");
          } else if (dataItem.requestStatus !== "PENDING") {
            dataItem.approvedExpireDate = "不适用";
          } else {
            dataItem.approvedExpireDate = "";
          }

          this.requestIdRequestDict[dataItem.requestId] = dataItem;
        });

        this.tableData = dataList;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.report-list {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 50px) !important;
  position: relative;
  .table-command {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
    margin-right: 2%;
  }
  .pagination {
    position: absolute;
    bottom: 0;
  }
}
.status-tag {
  cursor: pointer;
}
.tag-in-select {
  width: 100%;
  text-align: center;
}
.percentage-tag {
  min-width: 75px;
}
.dialog-form-textarea {
  width: 80%;
  margin-top: 10px;
}

::v-deep .el-pagination {
  text-align: center;
}
</style>
